import { createVNode as _createVNode, resolveComponent as _resolveComponent, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "flex" }
const _hoisted_2 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, null, -1)
const _hoisted_3 = { class: "flex-grow" }
const _hoisted_4 = /*#__PURE__*/_createVNode("div", { class: "mb-2 flex items-end space-x-2" }, [
  /*#__PURE__*/_createVNode("p", { class: "text-3xl" }, "Carga Masiva de Ajustes")
], -1)
const _hoisted_5 = { class: "flex items-center space-x-2" }
const _hoisted_6 = { class: "file-path border border-black w-100 h-8 w-full px-3 flex items-center rounded-md" }
const _hoisted_7 = { class: "text-gray-400" }
const _hoisted_8 = { key: 0 }
const _hoisted_9 = {
  key: 1,
  class: "font-italic"
}
const _hoisted_10 = { class: "flex" }
const _hoisted_11 = /*#__PURE__*/_createVNode("div", { class: "flex-grow" }, null, -1)
const _hoisted_12 = { class: "flex items-center space-x-2" }
const _hoisted_13 = /*#__PURE__*/_createVNode("hr", { class: "my-2" }, null, -1)
const _hoisted_14 = {
  key: 0,
  class: "my-2 bg-red-100 p-2 text-red-800 flex items-center justify-between border-2 border-red-500 rounded-md"
}
const _hoisted_15 = /*#__PURE__*/_createVNode("h4", null, "Error en la carga", -1)
const _hoisted_16 = {
  key: 1,
  class: "my-2 bg-green-100 p-2 text-green-800 flex items-center justify-between border-2 border-green-500 rounded-md"
}
const _hoisted_17 = /*#__PURE__*/_createVNode("h4", null, "Exito en la carga", -1)
const _hoisted_18 = { key: 2 }
const _hoisted_19 = /*#__PURE__*/_createVNode("h3", { class: "mb-2 text-xl" }, [
  /*#__PURE__*/_createVNode("strong", null, "Cargas Previas")
], -1)
const _hoisted_20 = { key: 3 }
const _hoisted_21 = /*#__PURE__*/_createVNode("p", { class: "text-center text-gray-400 py-5" }, "No hay cargas masivas previas", -1)
const _hoisted_22 = /*#__PURE__*/_createVNode("div", { class: "w-1/6" }, null, -1)
const _hoisted_23 = { class: "text-center text-2xl mb-4" }
const _hoisted_24 = /*#__PURE__*/_createVNode("p", { class: "text-center mb-3" }, "Se eliminara la carga seleccionada del 22-20-2025", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_button = _resolveComponent("ui-button")
  const _component_fa_icon = _resolveComponent("fa-icon")
  const _component_ui_modal = _resolveComponent("ui-modal")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode("div", _hoisted_3, [
      _hoisted_4,
      _createVNode("div", _hoisted_5, [
        _createVNode(_component_ui_button, {
          label: "Seleccionar",
          onClick: _ctx.pickFile,
          disabled: _ctx.isLoading
        }, null, 8, ["onClick", "disabled"]),
        _createVNode("div", _hoisted_6, [
          _createVNode("p", _hoisted_7, [
            (_ctx.file)
              ? (_openBlock(), _createBlock("span", _hoisted_8, _toDisplayString(_ctx.file.name), 1))
              : (_openBlock(), _createBlock("span", _hoisted_9, "No hay archivo seleccionado"))
          ])
        ]),
        _createVNode("input", {
          id: "fileinput",
          type: "file",
          ref: "fileRef",
          style: {"display":"none"},
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.charge && _ctx.charge(...args))),
          onChange: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.onFilePicked && _ctx.onFilePicked(...args))),
          accept: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
        }, null, 544)
      ]),
      _createVNode("div", _hoisted_10, [
        _hoisted_11,
        _createVNode("div", _hoisted_12, [
          _createVNode(_component_ui_button, {
            label: "Descargar Modelo",
            onClick: _ctx.downloadModelFile
          }, null, 8, ["onClick"]),
          _createVNode(_component_ui_button, {
            label: "Validar Archivo",
            onClick: _ctx.validateFile,
            disabled: !_ctx.file,
            loading: _ctx.isValidating
          }, null, 8, ["onClick", "disabled", "loading"]),
          _createVNode(_component_ui_button, {
            label: "Subir Archivo",
            onClick: _ctx.uploadFile,
            disabled: !_ctx.file,
            loading: _ctx.isLoading
          }, null, 8, ["onClick", "disabled", "loading"])
        ])
      ]),
      _hoisted_13,
      (_ctx.uploadState.show && !_ctx.uploadState.isValid)
        ? (_openBlock(), _createBlock("div", _hoisted_14, [
            _createVNode("div", null, [
              _hoisted_15,
              _createVNode("p", null, "Existen errores en el archivo, " + _toDisplayString(_ctx.uploadState.invalidEntriesQty) + " registros estan incorrectos", 1)
            ]),
            _createVNode("div", {
              class: "cursor-pointer hover:text-red-600 mr-4",
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.uploadState.show = false))
            }, [
              _createVNode(_component_fa_icon, {
                icon: ['fas', 'times'],
                class: "pt-1 text-red-500"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.uploadState.show && _ctx.uploadState.isValid)
        ? (_openBlock(), _createBlock("div", _hoisted_16, [
            _createVNode("div", null, [
              _hoisted_17,
              _createVNode("p", null, "Se han cargado " + _toDisplayString(_ctx.uploadState.validEntriesQty) + " registros", 1)
            ]),
            _createVNode("div", {
              class: "cursor-pointer hover:text-red-600 mr-4",
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.uploadState.show = false))
            }, [
              _createVNode(_component_fa_icon, {
                icon: ['fas', 'times'],
                class: "pt-1 text-green-500"
              })
            ])
          ]))
        : _createCommentVNode("", true),
      (_ctx.batches.length)
        ? (_openBlock(), _createBlock("div", _hoisted_18, [
            _hoisted_19,
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.batches, (batch, i) => {
              return (_openBlock(), _createBlock("p", {
                key: batch.batch
              }, [
                _createVNode("strong", null, "Carga " + _toDisplayString(i +1) + ".", 1),
                _createTextVNode(" " + _toDisplayString(batch.date) + " - Se crearon " + _toDisplayString(batch.count) + " registros - ", 1),
                _createVNode("span", {
                  class: "cursor-pointer text-red-800 hover:text-red-600",
                  onClick: ($event: any) => (_ctx.selectToDeleteFn(batch.batch))
                }, "ELIMINAR", 8, ["onClick"])
              ]))
            }), 128))
          ]))
        : (_openBlock(), _createBlock("div", _hoisted_20, [
            _hoisted_21
          ]))
    ]),
    _hoisted_22,
    _createVNode(_component_ui_modal, {
      modalState: _ctx.deleteModalState,
      "onUpdate:modalState": _cache[6] || (_cache[6] = ($event: any) => (_ctx.deleteModalState = $event))
    }, {
      default: _withCtx(() => [
        _createVNode("p", _hoisted_23, [
          _createVNode("strong", null, "Eliminar Carga - " + _toDisplayString(_ctx.selectedToDelete), 1)
        ]),
        _hoisted_24,
        _createVNode(_component_ui_button, {
          label: "Eliminar",
          onClick: _ctx.deleteBatchFn
        }, null, 8, ["onClick"]),
        _createVNode("p", {
          class: "text-center text-yellow-800 py-2 select-none cursor-pointer hover:bg-gray-50 rounded-md transition-all duration-300",
          onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.deleteModalState = false))
        }, "Cancelar")
      ]),
      _: 1
    }, 8, ["modalState"])
  ]))
}